var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLoveTiny = function SvgIconLoveTiny(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "icon-love-tiny",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    style: {
      enableBackground: "new 0 0 18 16"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065052601967083594120000004200819070287350197_",
    gradientUnits: "userSpaceOnUse",
    x1: 9,
    y1: 15.9506,
    x2: 9,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B84839"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D2675A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065052601967083594120000004200819070287350197_)"
    },
    d: "M9,1.8c-3.2-4.2-10.2-0.7-8.9,5     c1,3.9,5.6,7.4,7.7,8.8c0.7,0.5,1.6,0.5,2.3,0c2.2-1.4,6.8-4.9,7.7-8.8C19.2,1.1,12.2-2.3,9,1.8z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLoveTiny, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-love-tiny.e2317d32.svg";
export { ForwardRef as ReactComponent };